import axios from 'axios';
import {
  BLOG_CREATE_REQUEST,
  BLOG_CREATE_SUCCESS,
  BLOG_CREATE_FAIL,
  BLOG_CREATE_RESET,
  BLOG_LIST_REQUEST,
  BLOG_LIST_SUCCESS,
  BLOG_LIST_FAIL,
  BLOG_DETAILS_REQUEST,
  BLOG_DETAILS_SUCCESS,
  BLOG_DETAILS_FAIL,
  BLOG_UPDATE_REQUEST,
  BLOG_UPDATE_SUCCESS,
  BLOG_UPDATE_FAIL,
  BLOG_UPDATE_RESET,
  BLOG_DELETE_REQUEST,
  BLOG_DELETE_SUCCESS,
  BLOG_DELETE_FAIL,
  baseURL
} from './types';

// Utility: Get token from localStorage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return loginData.token || '';
};

// Create Blog: POST /api/appointmentDoctorBlogs/create (FormData)
export const createBlog = (formData) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_CREATE_REQUEST });
    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    };
    const { data } = await axios.post(`${baseURL}/api/appointmentDoctorBlogs/create`, formData, config);
    dispatch({ type: BLOG_CREATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: BLOG_CREATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// List Blogs: POST /api/appointmentDoctorBlogs/getall with filters in body
export const listBlogs = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_LIST_REQUEST });
    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const { data } = await axios.post(`${baseURL}/api/appointmentDoctorBlogs/getall`, filters, config);
    // If your API response is {success: 1, data: [...]}, use data.data:
    dispatch({ type: BLOG_LIST_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: BLOG_LIST_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// Get Blog Details: POST /api/appointmentDoctorBlogs/getone with ID in body
export const getBlogDetails = (blogId) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_DETAILS_REQUEST });
    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    // (check with your backend: possibly /getone instead of /details)
    const { data } = await axios.post(`${baseURL}/api/appointmentDoctorBlogs/getone`, { id: blogId }, config);
    dispatch({ type: BLOG_DETAILS_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: BLOG_DETAILS_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// Update Blog: PATCH /api/appointmentDoctorBlogs/patch with data in body (FormData for images)
export const updateBlog = (formData) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_UPDATE_REQUEST });
    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    };
    const { data } = await axios.patch(`${baseURL}/api/appointmentDoctorBlogs/update`, formData, config);
    dispatch({ type: BLOG_UPDATE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: BLOG_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// Delete Blog: DELETE /api/appointmentDoctorBlogs/delete with { id }
export const deleteBlog = (blogId) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_DELETE_REQUEST });
    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: { id: blogId }   // Axios DELETE with body requires "data" field
    };
    const { data } = await axios.delete(`${baseURL}/api/appointmentDoctorBlogs/delete`, config);
    dispatch({ type: BLOG_DELETE_SUCCESS, payload: data });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ type: BLOG_DELETE_FAIL, payload: error.response?.data?.message || error.message });
    return Promise.reject(error);
  }
};

// Reset Actions (useful for form and modal state)
export const resetCreateBlog = () => (dispatch) => {
  dispatch({ type: BLOG_CREATE_RESET });
};
export const resetUpdateBlog = () => (dispatch) => {
  dispatch({ type: BLOG_UPDATE_RESET });
};
